/**
 * @generated SignedSource<<fe4f9ee834340f3ed13c69cd1c39905a>>
 * @relayHash 21aa3001ba80f7011f8b970c73042410
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21aa3001ba80f7011f8b970c73042410

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DestroyBodyItemInput = {
  bodyItemId: string;
  clientMutationId?: string | null;
};
export type BodyItemDestroyMutation$variables = {
  input: DestroyBodyItemInput;
};
export type BodyItemDestroyMutation$data = {
  readonly destroyBodyItem: {
    readonly part: {
      readonly bodyItems: ReadonlyArray<{
        readonly id: string;
        readonly index: number;
      }>;
      readonly id: string;
    };
  } | null;
};
export type BodyItemDestroyMutation = {
  response: BodyItemDestroyMutation$data;
  variables: BodyItemDestroyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DestroyBodyItemPayload",
    "kind": "LinkedField",
    "name": "destroyBodyItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Part",
        "kind": "LinkedField",
        "name": "part",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BodyItem",
            "kind": "LinkedField",
            "name": "bodyItems",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "index",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BodyItemDestroyMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BodyItemDestroyMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "21aa3001ba80f7011f8b970c73042410",
    "metadata": {},
    "name": "BodyItemDestroyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8a2bd0af1040592d0070566b8d398066";

export default node;
